// sensei-app/client/widgets/PopularCoursesWidget.widget.js
export default {
    name: "PopularCoursesWidget",
    type: "ChartWidget",
    description: "Bar chart of the most popular courses by enrollment.",
    roles: ["courseAdmin"], 
    widget: {
        title: "Top 5 Popular Courses",
        size: "large",
        dataProvider: {
            main: {
                rpc: "CAdminCourseRpc.getDashboardStats",
                transform: (response) => response?.topCourses || []
            }
        },
        chartType: "bar",
        labelsField: "courseName",
        dataField: "enrollmentCount",
        datasetOptions: {
            label: "Enrollments",
            backgroundColor: 'var(--bs-primary)',
            borderColor: 'var(--bs-primary-border-subtle)'
        },
        options: {
            indexAxis: 'y',
            responsive: true,
            maintainAspectRatio: false,
            plugins: { legend: { display: false } }
        }
    }
};